module.exports = __webpack_public_path__ + "static/fillet-blade-b64fd4ffb59238bdc99e861a07f2d607.png";